import { Injectable,EventEmitter  } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs/internal/Subscription';
import { Subject } from 'rxjs/Subject';
import { DataService } from '../services/data.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class SignImageService {
  public onClose: Subject<boolean>;
  data : any = {
    invokeFirstComponentFunction : new EventEmitter(),
    invokeFirstComponentFunction1 : new EventEmitter(),
    invokeFirstComponentFunction2 : new EventEmitter(),
    invokeFirstComponentFunctionthumbnail : new EventEmitter(),
    invokeFirstComponentFunctionShowthumbnail : new EventEmitter(),
    invokeFirstComponentFunction3 : new EventEmitter(),
    invokeFirstComponentFunction4 : new EventEmitter(),
    invokeFirstComponentFunctionSigned : new EventEmitter(),
    invokeSubscriptionFunction : new EventEmitter(),
    invokeFinishFunction : new EventEmitter(),
    invokeActiveButtonNext : new EventEmitter(),
    invokeActiveButtonNextActive : new EventEmitter(),
    invokeShowIcon : new EventEmitter(),
    invokeDealHub : new EventEmitter(),
    invokeDealHubNext : new EventEmitter(),
    invokeDealHubNextForContacts : new EventEmitter(),
    invokeDealHubCancel : new EventEmitter(),
    invokePreviewBack : new EventEmitter(),
    invokeAddPaymentMethod : new EventEmitter(),
    invokeDealHubNextForProducts : new EventEmitter(),
    invokeSignFinishTrue : new EventEmitter(),
    invokeSignFinishFalse : new EventEmitter(),
    invokeSendDoc : new EventEmitter(),
    invokeSendDocDisbaled : new EventEmitter(),
    invokeSignDocDrop : new EventEmitter(),
    invokeSendDocBtnFalse : new EventEmitter(),
    invokeSendDocBtnTrue : new EventEmitter(),
    invokeUploadOffline : new EventEmitter(),
    invokeUploadOfflineActionDisabled : new EventEmitter(),
    invokeHubspotFieldValidation : new EventEmitter(),
    invokeHubspotFieldStopInterval : new EventEmitter(),
    invokeRulesData : new EventEmitter(),
	cancelPlan : new EventEmitter(),
    invokeDealHubNextSalesQuote : new EventEmitter(),
    invokeSalesQuoteDownloadDraft : new EventEmitter(),
    invokeSalesQuoteSendRequest : new EventEmitter(),
    invokeSalesReturnSuccess : new EventEmitter(),	
    invokeApproveFinishTrue : new EventEmitter(),
    invokeDealHubLineItems : new EventEmitter(),
    invokeDealHubLineItemsSync : new EventEmitter(),
    invokeSignDocPreviewLoading : new EventEmitter(),
    invokeViewApproveUploadDoc : new EventEmitter(),
    invokeViewApproveGroupUploadDoc : new EventEmitter(),
    invokeDocGroupUploadRecentDoc : new EventEmitter(),
    invokeExpireTrackDoc: new EventEmitter(),
    invokeWhenTabAccess: new EventEmitter(),
    invokeWhenSendDocKit: new EventEmitter(),
    invokeWhenSendDocKitClick: new EventEmitter(),
    invokeDealHubPreviewSettingsSave: new EventEmitter()
  }
  isAutoSaveEnabled = true;

  modalRefer;
  modalRefer401;

  subsVar: Subscription
  
  
  fontName : string;
  modalRef: BsModalRef;
  open = false;
  errorModalDisplay:boolean = false;
  constructor(private modalService: BsModalService,private dataService: DataService,private cookieService: CookieService) { }

  showModal(upgrade){
    // console.log("===upgrade======");
    // console.log(upgrade.elementRef);
    // console.log("===upgrade======");
    this.open = true;
    let className = upgrade.elementRef.nativeElement.parentElement.className;
    this.modalRef = this.modalService.show(upgrade,{keyboard: false, backdrop: 'static', ignoreBackdropClick: false,class:className });
  }
  count=0;
  showModalError(){
    // console.log("===upgrade======");
    // console.log(this.modalRefer);
    // console.log("===upgrade======");
    //let className = this.modalRefer.nativeElement.parentElement.className;

    if(this.errorModalDisplay==false){
      this.errorModalDisplay = true;
      this.open = true;
      this.modalRef = this.modalService.show(this.modalRefer,{keyboard: false, backdrop: 'static', ignoreBackdropClick: false });
      this.count = 1;
    }
  }


  showModalError401(){
    window.location.reload();
    // if(this.errorModalDisplay==false){
    //   this.errorModalDisplay = true;
    //   this.open = true;
    //   this.modalRef = this.modalService.show(this.modalRefer401,{keyboard: false, backdrop: 'static', ignoreBackdropClick: false });
    //   this.count = 1;
    // }
  }

  clearOfflineCookies(){
    this.cookieService.delete('uploaded_filename');
    this.cookieService.delete('file_name_after_upload');
    this.cookieService.delete('upload_offline');
    this.cookieService.delete('file_title');
    this.cookieService.delete('uploaded_document_id');
    this.cookieService.delete('action_type_quick_flow');
    this.cookieService.delete('free_flow');
    this.cookieService.delete('doc_title');
    this.cookieService.delete('sender_email_quick_flow');
    this.cookieService.delete('draft_user_doc_id');
    this.cookieService.delete('deal_id_quick_flow');
    this.cookieService.delete('draft_request_id');
  }

  closeModal(){
    this.errorModalDisplay = false;
    //this.onClose.next(null);
    this.open = false;
    this.modalRef.hide();
  }

  hideConfirmationModal(): void {
    //this.errorModalDisplay = false;
    //this.onClose.next(false);
    this.open = false;
    this.errorModalDisplay = false;
    this.modalRef.hide();
  }
  
  showActivateModal(upgrade){
    this.open = true;
    let className = upgrade.elementRef.nativeElement.parentElement.className;
    this.modalRef = this.modalService.show(upgrade,{keyboard: false, backdrop: 'static', ignoreBackdropClick: false,class:className });
  }


  closeActivateModal(){
    this.open = false;
    this.modalRef.hide();
  }

  getSignatureImage(font,sign_canvas,signType,cx_signCanvas,draw_canvas,font_Size,signature,initial){
    if(signType=='type'){
      if(font == 1){
        this.fontName = "'La Belle Aurore', cursive";
      }
      else if(font == 2){
        this.fontName = "'Shadows Into Light', cursive";
      }
      else if(font == 3){
        this.fontName = "'Nothing You Could Do', cursive";
      }
      else if(font == 4){
        this.fontName = "'Zeyada', cursive";
      }
      else if(font == 5){
        this.fontName = "'Dawning of a New Day', cursive";
      }
      else {
        this.fontName = "'Herr Von Muellerhoff', cursive";
      }
      if(initial=='true'){
        sign_canvas.width = 115;
        sign_canvas.height = 53;
      }
      else{
        sign_canvas.width = 180;
        sign_canvas.height = 53;
      }
      cx_signCanvas = sign_canvas.getContext('2d');
      cx_signCanvas.rect(255, 255, 255, 4);
      cx_signCanvas.fillStyle = "transparent";
      cx_signCanvas.fill();
      cx_signCanvas.font = font_Size+' '+this.fontName;
      cx_signCanvas.fillStyle = "#0100fb"; //"#145394";
      cx_signCanvas.fillText(signature, 5, 30);
      return sign_canvas.toDataURL("image/png");
    }
    else{
      return draw_canvas.toDataURL("image/png");
    }

  }

  linkButton(value){
    if(value=="save"){
      this.data.invokeFirstComponentFunction.emit();
    }
    else if(value=="reject"){
      this.data.invokeFirstComponentFunction1.emit();
    }else if(value=="approve"){
      this.data.invokeFirstComponentFunction2.emit();
    }
    else if(value=='thumbnail'){
      this.data.invokeFirstComponentFunctionthumbnail.emit();
    }
    else if(value=="showSelectedThumbnail"){
      this.data.invokeFirstComponentFunctionShowthumbnail.emit();
    }
    else if(value=="previewDocument"){
      this.data.invokeFirstComponentFunction3.emit();
    }
    else if(value=="updateTemplate"){
      this.data.invokeFirstComponentFunction4.emit();
    }else if(value=="send_doc"){
      this.data.invokeSendDoc.emit();
    }
    else{
      this.data.invokeFirstComponentFunction1.emit();
    }
  }

  allFeaturesList;
  
  allFeatures(beta_features,type){
    let Flagreturn = false;
    this.dataService.getAllAdminFeature().subscribe(
      data => {
        //console.log("allFeaturesallFeatures",data);
        if(data['success']==true){
          this.allFeaturesList = data['message'];
          if(typeof this.allFeaturesList!="undefined"){
            //console.log("====beta_featuresbeta_features====",beta_features);
            for(let i=0;i<this.allFeaturesList.length;i++){
              if(typeof beta_features!="undefined" && beta_features.length> 0){
                for(let j=0;j>beta_features.length;i++){
                  if(this.allFeaturesList[i].feature==type){
                    if(beta_features[j]==this.allFeaturesList[i].feature){
                      Flagreturn = true;
                    }
                  }  
                }
              }
            }
          }
        }
      },
      error => {

      }
    )
    return Flagreturn;
  }

  checkfeatureallowed(beta_features,enable_for_all,featurename){
    if(typeof featurename!="undefined"){
      featurename = featurename.toLowerCase();
      featurename = featurename.split(' ').join('_');
      console.log('feature to compare is ',featurename);
      let isavailable = 0;
      if(enable_for_all.length > 0){
        for(let k=0; k< enable_for_all.length;k++){
          let featurenametocompare = enable_for_all[k];
          //console.log('featurenametocompare ',featurenametocompare);
          if(featurenametocompare == featurename){
            isavailable = 1;
            return true;
          }
        }
      }
      //console.log('===============isavailable ',isavailable,beta_features);
      if(isavailable == 0){
        let featureasbeta = 0;
        if(beta_features.length > 0){
          for(let l=0; l<beta_features.length;l++){
            let featurenametocompare = beta_features[l];
            //console.log('BETAfeaturenametocompare ',featurenametocompare);
            if(featurenametocompare == featurename){
              featureasbeta = 1;
              return true;
            }
          }

          if(featureasbeta == 0){
            return false;
          }
        } else {
          return false;
        }

      }
    }
  }
}
